// G1-B: logo source. Pure helper (no "@/" imports) so Jest can test it.
// Default = logo kit in /public/logo; an Owner upload (version number from
// /api/public/branding) replaces it. PUTIH = dark backgrounds, HITAM = white pages.
export const VARIAN_LOGO = ["putih", "hitam"];

export function logoBawaan(varian) {
  return `/logo/soq-${varian === "hitam" ? "hitam" : "putih"}.png`;
}

// backendUrl "" = API on the same domain (production, G3-0).
export function logoUrl(info, varian, backendUrl = "") {
  const v = varian === "hitam" ? "hitam" : "putih";
  const versi = info && Number.isInteger(info[v]) ? info[v] : null;
  if (!versi) return logoBawaan(v);
  return `${backendUrl || ""}/api/public/logo/${v}?v=${versi}`;
}

// Credit appears only in the staff app (login + sidebar/drawer footer).
// Owner 2026-10-09: two lines; staff app + the public tracking and ACC pages only.
export const CREDIT = ["© 2026 SOQPRINT. All Rights Reserved.", "Powered by iartech."];
// owner 2026-10-17 (VERSI-APLIKASI): the readable version in the footer; owner 2026-10-23 (v2.17.3):
// just "v2.17.3" — the credit line above already says SOQPRINT, so the name is not repeated.
// (the build reads it from the file VERSI; "0" = unknown, then nothing is shown)
export const teksVersi = (nomor) => (nomor && nomor !== "0" ? `v${nomor}` : "");

// TAMPILAN-SOQ (owner 2026-10-10): tagline on the login and public customer pages.
export const TAGLINE = "Produksi Jersey Pertama di Papua Barat Daya";
